import {NovoProcesso} from "./novo-processo";

export class AlterarProcesso extends NovoProcesso{
  id: number;
  numeroProcesso: string;
  valorCausa: string;
  valorCondenacao: string;
  juiz: string;
}
